<form [formGroup]="accountForm">
  <ion-toolbar color="light">
    <ion-title
      >{{ account?.firstName }} {{ account?.lastName }}
      <ion-note *ngIf="account" style="display: block; font-style: italic"
        >{{ account.id }} &bull; {{ account.emailAddress }}</ion-note
      >
    </ion-title>
    <ion-buttons slot="end">
      <ion-button fill="solid" color="success" (click)="save()"
        >Save</ion-button
      >
      <!-- <ion-button fill="outline" color="warning">Merge</ion-button> -->
      <ion-button fill="outline" color="danger" (click)="deactivate()"
        >Deactivate</ion-button
      >
    </ion-buttons>
  </ion-toolbar>
  <ion-grid>
    <ion-row>
      <ion-col size="6">
        <ion-item
          [color]="
            !accountForm.controls['firstName'].valid &&
            (accountForm.controls['firstName'].dirty || submitAttempt)
              ? 'danger'
              : ''
          "
        >
          <ion-input label="First Name*" formControlName="firstName">
          </ion-input>
        </ion-item>
      </ion-col>
      <ion-col size="6">
        <ion-item
          [color]="
            !accountForm.controls['lastName'].valid &&
            (accountForm.controls['lastName'].dirty || submitAttempt)
              ? 'danger'
              : ''
          "
        >
          <ion-input label="Last Name*" formControlName="lastName"> </ion-input>
        </ion-item>
      </ion-col>
      <ion-col size="6">
        <ion-item
          [color]="
            !accountForm.controls['emailAddress'].valid &&
            (accountForm.controls['emailAddress'].dirty || submitAttempt)
              ? 'danger'
              : ''
          "
        >
          <ion-input label="Email*" formControlName="emailAddress"> </ion-input>
        </ion-item>
      </ion-col>
      <ion-col size="6">
        <ion-item
          [color]="
            !accountForm.controls['phone'].valid &&
            (accountForm.controls['phone'].dirty || submitAttempt)
              ? 'danger'
              : ''
          "
        >
          <ion-input label="Phone*" formControlName="phone"></ion-input>
        </ion-item>
      </ion-col>
      <ion-col size="6">
        <ion-item>
          <ion-input
            label="Date of Birth*"
            type="date"
            formControlName="birthDate"
          ></ion-input>
        </ion-item>
      </ion-col>
      <ion-col size="6">
        <ion-item
          [color]="
            !accountForm.controls['male'].valid &&
            (accountForm.controls['male'].dirty || submitAttempt)
              ? 'danger'
              : ''
          "
        >
          <ion-select label="Gender*" formControlName="male">
            <ion-select-option [value]="true">Male</ion-select-option>
            <ion-select-option [value]="false">Female</ion-select-option>
          </ion-select>
        </ion-item>
      </ion-col>
      <ion-col size="6">
        <ion-item
          [color]="
            !accountForm.controls['streetAddress'].valid &&
            (accountForm.controls['streetAddress'].dirty || submitAttempt)
              ? 'danger'
              : ''
          "
        >
          <ion-input
            label="Street Address*"
            formControlName="streetAddress"
          ></ion-input>
        </ion-item>
      </ion-col>
      <ion-col size="6">
        <ion-item
          [color]="
            !accountForm.controls['city'].valid &&
            (accountForm.controls['city'].dirty || submitAttempt)
              ? 'danger'
              : ''
          "
        >
          <ion-input label="City*" formControlName="city"> </ion-input>
        </ion-item>
      </ion-col>
      <ion-col size="6">
        <ion-item
          [color]="
            !accountForm.controls['state'].valid &&
            (accountForm.controls['state'].dirty || submitAttempt)
              ? 'danger'
              : ''
          "
        >
          <ion-select
            [label]="
              accountForm.controls['country'].value === 'Canada'
                ? 'Province*'
                : 'State*'
            "
            formControlName="state"
          >
            <ng-container
              *ngIf="accountForm.controls['country'].value === 'Canada'"
            >
              <ion-select-option value="ON">ON</ion-select-option>
              <ion-select-option value="QC">QC</ion-select-option>
              <ion-select-option value="NS">NS</ion-select-option>
              <ion-select-option value="NB">NB</ion-select-option>
              <ion-select-option value="MB">MB</ion-select-option>
              <ion-select-option value="BC">BC</ion-select-option>
              <ion-select-option value="PE">PE</ion-select-option>
              <ion-select-option value="SK">SK</ion-select-option>
              <ion-select-option value="AB">AB</ion-select-option>
              <ion-select-option value="NL">NL</ion-select-option>
            </ng-container>
            <ng-container
              *ngIf="accountForm.controls['country'].value !== 'Canada'"
            >
              <ion-select-option value="AK">AK</ion-select-option>
              <ion-select-option value="AL">AL</ion-select-option>
              <ion-select-option value="AR">AR</ion-select-option>
              <ion-select-option value="AZ">AZ</ion-select-option>
              <ion-select-option value="CA">CA</ion-select-option>
              <ion-select-option value="CO">CO</ion-select-option>
              <ion-select-option value="CT">CT</ion-select-option>
              <ion-select-option value="DE">DE</ion-select-option>
              <ion-select-option value="FL">FL</ion-select-option>
              <ion-select-option value="GA">GA</ion-select-option>
              <ion-select-option value="HI">HI</ion-select-option>
              <ion-select-option value="IA">IA</ion-select-option>
              <ion-select-option value="ID">ID</ion-select-option>
              <ion-select-option value="IL">IL</ion-select-option>
              <ion-select-option value="IN">IN</ion-select-option>
              <ion-select-option value="KS">KS</ion-select-option>
              <ion-select-option value="KY">KY</ion-select-option>
              <ion-select-option value="LA">LA</ion-select-option>
              <ion-select-option value="MA">MA</ion-select-option>
              <ion-select-option value="MD">MD</ion-select-option>
              <ion-select-option value="ME">ME</ion-select-option>
              <ion-select-option value="MI">MI</ion-select-option>
              <ion-select-option value="MN">MN</ion-select-option>
              <ion-select-option value="MO">MO</ion-select-option>
              <ion-select-option value="MS">MS</ion-select-option>
              <ion-select-option value="MT">MT</ion-select-option>
              <ion-select-option value="NC">NC</ion-select-option>
              <ion-select-option value="ND">ND</ion-select-option>
              <ion-select-option value="NE">NE</ion-select-option>
              <ion-select-option value="NH">NH</ion-select-option>
              <ion-select-option value="NJ">NJ</ion-select-option>
              <ion-select-option value="NM">NM</ion-select-option>
              <ion-select-option value="NV">NV</ion-select-option>
              <ion-select-option value="NY">NY</ion-select-option>
              <ion-select-option value="OH">OH</ion-select-option>
              <ion-select-option value="OK">OK</ion-select-option>
              <ion-select-option value="OR">OR</ion-select-option>
              <ion-select-option value="PA">PA</ion-select-option>
              <ion-select-option value="RI">RI</ion-select-option>
              <ion-select-option value="SC">SC</ion-select-option>
              <ion-select-option value="SD">SD</ion-select-option>
              <ion-select-option value="TN">TN</ion-select-option>
              <ion-select-option value="TX">TX</ion-select-option>
              <ion-select-option value="UT">UT</ion-select-option>
              <ion-select-option value="VA">VA</ion-select-option>
              <ion-select-option value="VT">VT</ion-select-option>
              <ion-select-option value="WA">WA</ion-select-option>
              <ion-select-option value="WI">WI</ion-select-option>
              <ion-select-option value="WV">WV</ion-select-option>
              <ion-select-option value="WY">WY</ion-select-option>
            </ng-container>
          </ion-select>
        </ion-item>
      </ion-col>
      <ion-col size="6">
        <ion-item
          [color]="
            !accountForm.controls['zip'].valid &&
            (accountForm.controls['zip'].dirty || submitAttempt)
              ? 'danger'
              : ''
          "
        >
          <ion-input label="Zip*" formControlName="zip"></ion-input>
        </ion-item>
      </ion-col>
      <ion-col size="12">
        <ion-item
          [color]="
            !accountForm.controls['country'].valid &&
            (accountForm.controls['country'].dirty || submitAttempt)
              ? 'danger'
              : ''
          "
        >
          <ion-select
            label="Country*"
            formControlName="country"
            style="text-align: right"
          >
            <ion-select-option>United States</ion-select-option>
            <ion-select-option>Canada</ion-select-option>
          </ion-select>
        </ion-item>
      </ion-col>
    </ion-row>
  </ion-grid>
</form>
